import {
  staticCategories,
  baseCatTranslation,
  baseSubTranslation,
  buildTranslations,
  sortTree,
} from "../products/categoriesModel";

// Start from the bundled static taxonomy so the navbar/routing render
// instantly and keep working even if Firestore is unreachable. Once the
// `categories` collection loads, SET_CATEGORIES overlays the live data.
const initialState = {
  tree: staticCategories,
  catTranslation: baseCatTranslation,
  subTranslation: baseSubTranslation,
  loaded: false,
  source: "static",
};

const categories = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CATEGORIES": {
      const tree = sortTree(action.payload || []);
      // If Firestore is empty, keep the static fallback rather than blanking
      // out the whole navigation.
      if (!tree.length) {
        return { ...state, loaded: true };
      }
      const derived = buildTranslations(tree);
      return {
        tree,
        // Base maps stay underneath so labels for retired slugs still resolve.
        catTranslation: { ...baseCatTranslation, ...derived.catTranslation },
        subTranslation: { ...baseSubTranslation, ...derived.subTranslation },
        loaded: true,
        source: "firestore",
      };
    }
    case "CATEGORIES_LOAD_FAILED":
      return { ...state, loaded: true };
    default:
      return state;
  }
};

export default categories;
